export default __webpack_public_path__ + "static/media/pro-page.526aa8fe.jpg";